<template>
  <v-app>
    <v-app-bar app>
      <v-img src="@/assets/logo.png" max-width="40" contain />
      <v-toolbar-title>Hermes</v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App'
}
</script>
